export default "__VITE_ASSET__DYNHfp73__"